<template>
  <div class="sign">
    <div class="sign-item">
      <div class="item-top">
        <div>
          <p>货柜号</p>
          <p>{{ list.totalDetail.containerNo }}({{list.totalDetail.jpContainerNo}})</p>
        </div>

        <div @click="showMore(list.totalDetail.stockTransferNo)">
          <p>调拨单号</p>
          <p>
            {{
              (list.totalDetail ? list.totalDetail.stockTransferNo : "")
                | lenLimit
            }}
          </p>
        </div>

        <div>
          <p>总箱数</p>
          <p>{{ list.totalDetail ? list.totalDetail.totalBoxCount : "" }}</p>
        </div>
      </div>

      <van-tabs
        type="card"
        color="#ffffff"
        background="#aaaaaa"
        title-inactive-color="#000000"
        title-active-color="#000000"
        sticky
        @click="tabsClick"
      >
        <van-tab
          :title="`待备柜（${
            list.totalDetail ? list.totalDetail.waitSyncBoxCount : 0
          }）`"
        ></van-tab>
        <van-tab
          :title="`待装车（${
            list.totalDetail ? list.totalDetail.forLoadingBoxCount : 0
          }）`"
        ></van-tab>
      </van-tabs>

      <template v-if="startSearch">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <template v-else>
        <template v-if="list.detail.length">
          <ul class="bale-sku">
            <li
              @click="toDetail(item)"
              v-for="(item, index) in list.detail"
              :key="index"
            >
              <div>
                <div class="sign-list">
                  <p>SKU：{{ item.skuCode }}</p>
                  <p>
                    箱数：{{ item.boxCount }}
                    <span class="red" v-if="item.remark">{{
                      item.remark
                    }}</span>
                  </p>
                </div>
                <div class="sign-list">
                  <p>发货编码：{{ item.sourceNo }}</p>
                  <p>总数量：{{ item.packQty }}</p>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          <van-empty image="search" description="暂无数据" />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  Dialog,
} from "vant";
import { getLabelingList } from "@/api/mobile/labeling_api";
import { mapState, mapMutations } from "vuex";
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      startSearch: false,
      isReadonly: false,
      showPopover: false,
      tabType: "待备柜",
      actions: [],
    };
  },

  filters: {
    lenLimit(data) {
      if (data && data.length > 15) {
        return `${data.substring(0, 15)}...`;
      }
      return data;
    },
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({ warehouse: (state) => state.common.warehouse }),
  },

  methods: {
    ...mapMutations({
      saveMobileTitle: "saveMobileTitle",
    }),
    init() {
      // const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
      // this.$set(this.search, 'warehouseId', _warehouse.warehouseId)

      this.getList();
    },
    getList(type) {
      const { stockingTaskID } = this.$route.query;

      const data = {
        StockingTaskID: stockingTaskID,
        statusType: this.tabType,
      };

      this.startSearch = true;

      getLabelingList(data).then((res) => {
        this.startSearch = false;
        if (res.status === 200) {
          const { response } = res;

          if (!response) Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },
    toDetail(item) {
      const { shippingPlanDetailID, stockingTaskID } = item;
      this.$router.push({
        path: "/mobile/labelingDetail",
        query: { shippingPlanDetailID, stockingTaskID, tabType: this.tabType },
      });
    },
    tabsClick(n, t) {
      this.tabType = n === 0 ? "待备柜" : "待装车";
      this.getList();
    },

    showMore(str) {
      Dialog.alert({
        title: "调拨单号",
        confirmButtonText: "确定",
        closeOnClickOverlay: true,
        message: str,
      }).then(() => {
        // on close
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 90px;
}

.sign-toSearch {
  width: 100%;
  height: 51%;
  min-height: 46px;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}

::v-deep .van-tabs--card {
  border-bottom: 1px solid #ccc;
}

.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}
.item-top {
  display: flex;
  border-bottom: 1px solid #ccc;
  padding: 15px 0;
  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
.sign-list {
  padding-left: 5%;
}
p {
  margin: 5px 0;
}
@media screen and (max-width: 350px) {
  .item-top {
    p {
      font-size: 14px;
      &:last-child {
        font-size: 12px;
      }
    }
  }
}
</style>